// dependencies
import { useQuery } from "@tanstack/react-query";

import { getGroups } from "../../services";

// api services

export const useGroups = () => {
	return useQuery({
		queryKey: ["groups"],
		queryFn: async () => {
			const results = await getGroups();

			if (results?.errors?.length > 0) {
				throw new Error(results.errors.join(", "));
			}

			return results?.groups;
		},
		meta: {
			errorMessage: "There was an error getting the groups.",
		},
	});
};
